import IntroSequence from "./sections/intro-sequence";
import Loader from "./components/loaders";
import ScrollManager from "./classes/scroll-manager";
import Scene from "./classes/scene";
import SceneManager from "./classes/scene-manager";
import {delay, getEl} from "./helpers";
import StickyProgress from "./components/sticky-progress";
import AnimatedHeadings from "./components/animated-headings";
import Impact from "./sections/impact";
import ParallaxManager from "./classes/parallax-manager";
import AnimatedImages from "./components/animated-images";
import CustomersDependOnUs from "./sections/customers-depend-on-us";
import DrillBits from "./sections/drill-bits";
import ScrolllockedAnimations from "./components/scrolllocked-animations";
import NumberTicker from "./sections/number-ticker";
import SidewaysScroller from "./sections/sideways-scroller";
import SpotlightAnimations from "./components/spotlight-animations";
import Modals from './components/modals';
import RoadmapToNetZero from "./sections/roadmap-to-net-zero";
import ResilientFuture from "./sections/resilient-future";
import People from "./sections/people";
import UnlockingHumanPotential from "./sections/unlocking-human-potential";
import ProtectingNature from "./sections/protecting-nature";
import Circularity from "./sections/circularity";
import ContinuousDiscovery from "./sections/continuous-discovery";
import Extro from "./sections/extro";
import Careers from "./sections/careers";
import BackToTop from "./components/back-to-top";
import ResponsiveWatcher from "./classes/responsive-watcher";
import Analytics from "./classes/analytics";
import Globals from "./classes/globals";
import WalkTheTalk from "./sections/walk-the-talk";
import TransitionTech from "./sections/transition-tech";

export default class App {

	scroller: ScrollManager;
	scener: SceneManager;
	parallaxer: ParallaxManager;
	scrolllocker: ScrolllockedAnimations;
	spotlighter: SpotlightAnimations;

	loader: Loader;
	progresser: StickyProgress;
	headinganimator: AnimatedHeadings;
	imageanimator: AnimatedImages;
	modaller: Modals;
	backtotopper: BackToTop;
	responser: ResponsiveWatcher;
	

	inited: boolean;
	loaded: boolean;

	constructor() {

		//Detect Safari:
		const userAgent = window.navigator.userAgent;
		Globals.isSafari = (/(iPad|iPhone|iPod)/gi).test(userAgent) &&
										!(/CriOS/).test(userAgent) &&
										!(/FxiOS/).test(userAgent) &&
										!(/OPiOS/).test(userAgent) &&
										!(/mercury/).test(userAgent);
		(window as any).brvIsSafari = Globals.isSafari;
		
		window.addEventListener("load", this.onDocumentFinishedLoading.bind(this));
		this.inited = false;
		this.loaded = false;
		if (document.readyState !== "loading") {
			this.onDocumentReady();
		} else {
			document.addEventListener("DOMContentLoaded", this.onDocumentReady.bind(this));
		}
	}

	async onDocumentFinishedLoading() {
		//console.log("Document Loaded.");
		if (this.inited) {
			this.loader.finishAndRemove();
		}
		this.loaded = true;
	}

	onDocumentReady() {
		//console.log("Document started loading...");
		
		//https://stackoverflow.com/questions/28360978/how-can-i-get-browser-scrollbar-width
		document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.offsetWidth) + 'px');
		
		const mainEl = getEl('#slb-report');
		
		if (Globals.isSafari)
		{
			const viewport = document.querySelector("meta[name=viewport]");
			if (viewport)	viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
		}
		
		//Infrastructure
		this.responser = new ResponsiveWatcher(this);
		this.scroller = new ScrollManager(this);
		this.scener = new SceneManager(this);
		this.parallaxer = new ParallaxManager(this);
		this.scrolllocker = new ScrolllockedAnimations(this);
		this.spotlighter = new SpotlightAnimations(this);

		//Bespoke components:
		this.loader = new Loader();
		this.progresser = new StickyProgress(this);
		this.headinganimator = new AnimatedHeadings(this);
		this.imageanimator = new AnimatedImages(this);
		this.modaller = new Modals(this);
		this.backtotopper = new BackToTop(this);

		//Scenes:
		this.scener.registerScene(IntroSequence, '#intro-sequence');
		this.scener.registerScene(Impact, '#impact-section');
		this.scener.registerScene(CustomersDependOnUs, '#customers-depend-on-us');
		this.scener.registerScene(TransitionTech, '#transition-tech');
		this.scener.registerScene(DrillBits, '#drillbits-1');
		this.scener.registerScene(NumberTicker, '#number-ticker');
		this.scener.registerScene(SidewaysScroller, '#sideways-scroller');
		this.scener.registerScene(WalkTheTalk, '#walk-the-talk');
		this.scener.registerScene(RoadmapToNetZero, '#roadmap-to-net-zero');
		this.scener.registerScene(ResilientFuture, '#resilient-future');
		this.scener.registerScene(People, '#people');
		//this.scener.registerScene(UnlockingHumanPotential, '#human-potential');
		this.scener.registerScene(ProtectingNature, '#protecting-nature');
		this.scener.registerScene(Circularity, '#circularity');
		this.scener.registerScene(ContinuousDiscovery, '#continuous-discovery');
		this.scener.registerScene(Extro, '#extro');
		this.scener.registerScene(Careers, '#careers');

		this.scroller.recalculate();
		this.scroller.onScroll();
		this.scener.onResize();

		Analytics.addTrackingToAllLinksOnPage();
		
		this.inited = true;
		if (this.loaded) this.onDocumentFinishedLoading();

	}

}

const app:App = new App();

(window as any).slbreport = app;


